import React, {useEffect} from 'react';
import {loadTimelineData} from 'anima-timeline';
import "./InsightPage.css";
import {Link} from "react-router-dom";
import NavBar from "../NavBar";
import Footer from "../Footer";
import {InSights} from "../../data";


function App() {
  return <X06InsightsPageTablet {...x06InsightsPageTabletData} />;
}

export default App;

function X06InsightsPageTablet(props) {
  const {
    insights,
    rectangle76,
    text149,
    text1492,
    text1493,
    text1494,
    text1495,
    text1496,
    frame144Props,
    insightsCardProps,
    insightsCard2Props,
    insightsCardProps2,
    insightsCard2Props2,
    insightsCardProps3,
    insightsCard2Props3,
    insightsCard7Props,
    insightsCard8Props,
    //footer5Props,
  } = props;

  return (
    <div className="ipt-container-center-horizontal">
      <div className="ipt-x06-insights-page-tablet screen">
        {/* <Frame144 group86Props={frame144Props.group86Props} iconMenuProps={frame144Props.iconMenuProps} /> */}
        <NavBar/>
        <div className="ipt-insights ipt-valign-text-middle ipt-typographyheadlineh4-extrabold-24">{insights}</div>
        {/* <img className="ipt-rectangle-76" src={rectangle76} /> */}
        <img className="ipt-rectangle-76" src={InSights.InsightsHeader} alt="Webuildd Insights"/>
        <div className="ipt-text-1 ipt-typography-body-smalltext-14-regular">
          <p>{text149}</p>
          <p>{text1492}</p>
          <p>{text1493}</p>
          <p>{text1494}</p>
          <p>{text1495}</p>
          <p>{text1496}</p>
        </div>
        <div className="ipt-frame-1635">
          <div className="ipt-frame-1632">
            <InsightsCard
              x1600I27322861202={insightsCardProps.x1600I27322861202}
              text2={insightsCardProps.text2}
              button8Props={insightsCardProps.button8Props}
            />
            <InsightsCard2
              x1600I27322862202={insightsCard2Props.x1600I27322862202}
              propertyTaxI27322={insightsCard2Props.propertyTaxI27322}
              button8Props={insightsCard2Props.button8Props}
            />
          </div>
          <div className="ipt-frame-163">
            <InsightsCard3
              x1600I27322864202={insightsCardProps2.x1600I27322864202}
              propertyTaxI27322={insightsCardProps2.propertyTaxI27322}
              button8Props={insightsCardProps2.button8Props}
            />
            <InsightsCard4
              x1600I27322865202={insightsCard2Props2.x1600I27322865202}
              propertyTaxI27322={insightsCard2Props2.propertyTaxI27322}
              button8Props={insightsCard2Props2.button8Props}
            />
          </div>
          <div className="ipt-frame-163">
            <InsightsCard5
              x1600I27322867202={insightsCardProps3.x1600I27322867202}
              propertyTaxI27322={insightsCardProps3.propertyTaxI27322}
              button8Props={insightsCardProps3.button8Props}
            />
            <InsightsCard6
              x1600I27322868202={insightsCard2Props3.x1600I27322868202}
              propertyTaxI27322={insightsCard2Props3.propertyTaxI27322}
              button8Props={insightsCard2Props3.button8Props}
            />
          </div>
          <div className="ipt-frame-163">
          <InsightsCard7
            x1600I27322869202={insightsCard7Props.x1600I27322869202}
            propertyTaxI27322={insightsCard7Props.propertyTaxI27322}
            button8Props={insightsCard7Props.button8Props}
          />
          <InsightsCard8
            x1600I27322869202={insightsCard8Props.x1600I27322869202}
            propertyTaxI27322={insightsCard8Props.propertyTaxI27322}
            button8Props={insightsCard8Props.button8Props}
          />
          </div>
        </div>
        {/* <Footer5 {...footer5Props} /> */}
        <Footer />
      </div>
    </div>
  );
}


function Frame144(props) {
  const { group86Props, iconMenuProps } = props;

  return (
    <div className="ipt-frame-144">
      <Group86 group85={group86Props.group85} whiteProps={group86Props.whiteProps} />
      <IconMenu vector2={iconMenuProps.vector2} vector3={iconMenuProps.vector3} />
    </div>
  );
}


function Group86(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="ipt-group-86">
      <White src={whiteProps.src} />
      <img className="ipt-group-85" src={group85} />
    </div>
  );
}


function White(props) {
  const { src } = props;

  return (
    <div className="ipt-white">
      <img className="ipt-vector" src={src} />
    </div>
  );
}


function IconMenu(props) {
  const { vector2, vector3 } = props;

  return (
    <div className="ipt-icon-menu">
      <img
        className="ipt-vector-2"
        src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg"
      />
      <img className="ipt-vector-1" src={vector2} />
      <img className="ipt-vector-1" src={vector3} />
    </div>
  );
}


function InsightsCard(props) {
  const { x1600I27322861202, text2, button8Props } = props;

  return (
    <div className="ipt-insights-card">
      <div className="ipt-group-69">
        <h1 className="ipt-x1600-i27322861202 ipt-valign-text-middle ipt-typographyheadlineh3-extrabold-30">{x1600I27322861202}</h1>
        <div className="ipt-text-2 ipt-valign-text-middle ipt-typography-body-smalltext-14-regular">{text2}</div>
      </div>
      <Link to="/insightdetails-bbmp">
        <Button8>{button8Props.children}</Button8>
      </Link>
    </div>
  );
}


function Button8(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(i273228612022185TimelineData);
  }, []);

  return (
    <div className="ipt-i27322861-2022185 ipt-component ipt-component-wrapper not-ready">
      <div className="ipt-master-button-tQxyfh">
        <div className="ipt-button-i2732286120-pAPHLp ipt-valign-text-middle">{children}</div>
      </div>
    </div>
  );
}

const i273228612022185TimelineData = [
  {
    initial_state_name: "Property-1=Primary",
    root_element: ".i27322861-2022185",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {},
      },
    },
  },
];


function InsightsCard2(props) {
  const { x1600I27322862202, propertyTaxI27322, button8Props } = props;

  return (
    <div className="ipt-insights-card-1">
      <div className="ipt-group-69-1">
        <div className="ipt-x1600-i27322862202 ipt-valign-text-middle ipt-typographyheadlineh3-extrabold-30">
          {x1600I27322862202}
        </div>
        <div className="ipt-property-tax-i27322 ipt-valign-text-middle ipt-typography-body-smalltext-14-regular">
          {propertyTaxI27322}
        </div>
      </div>
      <Link to="/insightdetails-bwssb">
        <Button8>{button8Props.children}</Button8>
      </Link>
    </div>
  );
}


function InsightsCard3(props) {
  const { x1600I27322864202, propertyTaxI27322, button8Props } = props;

  return (
    <div className="ipt-insights-card-2">
      <div className="ipt-group-69-2">
        <div className="ipt-x1600-i27322864202 ipt-valign-text-middle ipt-typographyheadlineh3-extrabold-30">
          {x1600I27322864202}
        </div>
        <div className="ipt-property-tax-i27322-1 ipt-valign-text-middle ipt-typography-body-smalltext-14-regular">
          {propertyTaxI27322}
        </div>
      </div>
      <Link to="/insightdetails-bescom">
        <Button8>{button8Props.children}</Button8>
      </Link>
    </div>
  );
}


function InsightsCard4(props) {
  const { x1600I27322865202, propertyTaxI27322, button8Props } = props;

  return (
    <div className="ipt-insights-card-3">
      <div className="ipt-group-69-3">
        <div className="ipt-x1600-i27322865202 ipt-valign-text-middle ipt-typographyheadlineh3-extrabold-30">
          {x1600I27322865202}
        </div>
        <div className="ipt-property-tax-i27322-2 ipt-valign-text-middle ipt-typography-body-smalltext-14-regular">
          {propertyTaxI27322}
        </div>
      </div>
      <Link to="/insightdetails-procedure">
        <Button8>{button8Props.children}</Button8>
      </Link>
    </div>
  );
}


function InsightsCard5(props) {
  const { x1600I27322867202, propertyTaxI27322, button8Props } = props;

  return (
    <div className="ipt-insights-card-4">
      <div className="ipt-group-69-4">
        <div className="ipt-x1600-i27322867202 ipt-valign-text-middle ipt-typographyheadlineh3-extrabold-30">
          {x1600I27322867202}
        </div>
        <p className="ipt-property-tax-i27322-3 ipt-valign-text-middle ipt-typography-body-smalltext-14-regular">
          {propertyTaxI27322}
        </p>
      </div>
      <Link to="/insightdetails-vaastu">
        <Button8>{button8Props.children}</Button8>
      </Link>
    </div>
  );
}


function InsightsCard6(props) {
  const { x1600I27322868202, propertyTaxI27322, button8Props } = props;

  return (
    <div className="ipt-insights-card-5">
      <div className="ipt-group-69-5">
        <div className="ipt-x1600-i27322868202 ipt-valign-text-middle ipt-typographyheadlineh3-extrabold-30">
          {x1600I27322868202}
        </div>
        <div className="ipt-property-tax-i27322-4 ipt-valign-text-middle ipt-typography-body-smalltext-14-regular">
          {propertyTaxI27322}
        </div>
      </div>
      <Link to="/insightdetails-byelaws">
        <Button8>{button8Props.children}</Button8>
      </Link>
    </div>
  );
}


function InsightsCard7(props) {
  const { x1600I27322869202, propertyTaxI27322, button8Props } = props;

  return (
    <div className="ipt-insights-card-6">
      <div className="ipt-group-69-6">
        <div className="ipt-x1600-i27322869202 ipt-valign-text-middle ipt-typographyheadlineh3-extrabold-30">
          {x1600I27322869202}
        </div>
        <div className="ipt-property-tax-i27322-5 ipt-valign-text-middle ipt-typography-body-smalltext-14-regular">
          {propertyTaxI27322}
        </div>
      </div>
      <Link to="/insightdetails-tips&ideas">
        <Button8>{button8Props.children}</Button8>
      </Link>
    </div>
  );
}

function InsightsCard8(props) {
  const { x1600I27322869202, propertyTaxI27322, button8Props } = props;

  return (
    <div className="ipt-insights-card-7">
      <div className="ipt-group-69-6">
        <div className="ipt-x1600-i27322869202 ipt-valign-text-middle ipt-typographyheadlineh3-extrabold-30">
          {x1600I27322869202}
        </div>
        <div className="ipt-property-tax-i27322-5 ipt-valign-text-middle ipt-typography-body-smalltext-14-regular">
          {propertyTaxI27322}
        </div>
      </div>
      <Link to="/insightdetails-budget">
        <Button8>{button8Props.children}</Button8>
      </Link>
    </div>
  );
}


// function Footer5(props) {
//   const {
//     group85,
//     place,
//     overlapGroup,
//     vector2,
//     phone,
//     overlapGroup1,
//     vector3,
//     text15,
//     text14,
//     contactWebuildCom,
//     quickLinks,
//     aboutUs,
//     projects,
//     gallery,
//     knowledgeTransfer,
//     blogs,
//     faqs,
//     group872Props,
//   } = props;

//   return (
//     <div className="ipt-footer">
//       <div className="ipt-flex-row-1">
//         <img
//           className="ipt-vector-3"
//           src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-148@2x.svg"
//         />
//         <img className="ipt-group-85-1" src={group85} />
//         <Group872
//           overlapGroup={group872Props.overlapGroup}
//           vector2={group872Props.vector2}
//           facebookAppSymbolProps={group872Props.facebookAppSymbolProps}
//           twitterProps={group872Props.twitterProps}
//         />
//       </div>
//       <div className="ipt-flex-row-2">
//         <div className="ipt-group-32">
//           <div className="ipt-place ipt-valign-text-middle ipt-typographyheadlineh5-extrabold-20">{place}</div>
//           <div className="ipt-flex-row-3">
//             <div className="ipt-flex-col">
//               <div className="ipt-map-pin-1">
//                 <div className="ipt-overlap-group" style={{ backgroundImage: `url(${overlapGroup})` }}>
//                   <img className="ipt-vector-4" src={vector2} />
//                 </div>
//               </div>
//               <div className="ipt-phone" style={{ backgroundImage: `url(${phone})` }}></div>
//               <div className="ipt-mail">
//                 <div className="ipt-overlap-group1" style={{ backgroundImage: `url(${overlapGroup1})` }}>
//                   <img className="ipt-vector-5" src={vector3} />
//                 </div>
//               </div>
//             </div>
//             <div className="ipt-flex-col-1">
//               <p className="ipt-text-4 ipt-typography-body-smalltext-14-regular">{text15}</p>
//               <div className="ipt-flex-col-item ipt-valign-text-middle ipt-typography-body-smalltext-14-regular">{text14}</div>
//               <div className="ipt-flex-col-item ipt-valign-text-middle ipt-typography-body-smalltext-14-regular">
//                 {contactWebuildCom}
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="ipt-group-147">
//           <div className="ipt-quick-links ipt-valign-text-middle ipt-typographyheadlineh5-extrabold-20">{quickLinks}</div>
//           <div className="ipt-flex-row-4">
//             <div className="ipt-about-us ipt-valign-text-middle ipt-typographybody16-regular">{aboutUs}</div>
//             <div className="ipt-projects ipt-valign-text-middle ipt-typographybody16-regular">{projects}</div>
//           </div>
//           <div className="ipt-flex-row">
//             <div className="ipt-gallery ipt-valign-text-middle ipt-typographybody16-regular">{gallery}</div>
//             <div className="ipt-knowledge-transfer ipt-valign-text-middle ipt-typographybody16-regular">{knowledgeTransfer}</div>
//           </div>
//           <div className="ipt-flex-row">
//             <div className="ipt-blogs ipt-valign-text-middle ipt-typographybody16-regular">{blogs}</div>
//             <div className="ipt-fa-qs ipt-valign-text-middle ipt-typographybody16-regular">{faqs}</div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }


function Group872(props) {
  const { overlapGroup, vector2, facebookAppSymbolProps, twitterProps } = props;

  return (
    <div className="ipt-group-87">
      <FacebookAppSymbol src={facebookAppSymbolProps.src} />
      <div className="ipt-instagram">
        <div className="ipt-overlap-group-1" style={{ backgroundImage: `url(${overlapGroup})` }}>
          <img
            className="ipt-vector-6"
            src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-18@2x.svg"
          />
          <img className="ipt-vector-7" src={vector2} />
        </div>
      </div>
      <Twitter src={twitterProps.src} />
    </div>
  );
}


function FacebookAppSymbol(props) {
  const { src } = props;

  return (
    <div className="ipt-facebook-app-symbol">
      <img className="ipt-f-1" src={src} />
    </div>
  );
}


function Twitter(props) {
  const { src } = props;

  return (
    <div className="ipt-twitter">
      <img className="ipt-vector-8" src={src} />
    </div>
  );
}

const whiteData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-98@2x.svg",
};

const group86Data = {
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/WebuilddLogo.svg",
    whiteProps: whiteData,
};

const iconMenuData = {
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
    vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
};

const frame144Data = {
    group86Props: group86Data,
    iconMenuProps: iconMenuData,
};

const button8Data = {
    children: "VIEW DETAILS",
};

const insightsCardData = {
    x1600I27322861202: "BBMP",
    text2: "Property Tax",
    button8Props: button8Data,
};

const button82Data = {
    children: "VIEW DETAILS",
};

const insightsCard2Data = {
    x1600I27322862202: "BWSSB",
    propertyTaxI27322: "Water Supply",
    button8Props: button82Data,
};

const button83Data = {
    children: "VIEW DETAILS",
};

const insightsCard3Data = {
    x1600I27322864202: "BESCOM",
    propertyTaxI27322: "Electricity Provider",
    button8Props: button83Data,
};

const button84Data = {
    children: "VIEW DETAILS",
};

const insightsCard4Data = {
    x1600I27322865202: "Procedure",
    propertyTaxI27322: "Steps taken for Construction",
    button8Props: button84Data,
};

const button85Data = {
    children: "VIEW DETAILS",
};

const insightsCard5Data = {
    x1600I27322867202: "Vaastu",
    propertyTaxI27322: "Boost positive energy in home",
    button8Props: button85Data,
};

const button86Data = {
    children: "VIEW DETAILS",
};

const insightsCard6Data = {
    x1600I27322868202: "Bye Laws",
    propertyTaxI27322: "Legal Documentation",
    button8Props: button86Data,
};

const button87Data = {
    children: "VIEW DETAILS",
};

const insightsCard7Data = {
    x1600I27322869202: "Tips & Ideas",
    propertyTaxI27322: "Construction Tips & Ideas",
    button8Props: button87Data,
};

const button88Data = {
  children: "VIEW DETAILS",
};

const insightsCard8Data = {
  x1600I27322869202: "Budget",
  propertyTaxI27322: "Construction Budget",
  button8Props: button88Data,
};

const facebookAppSymbolData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/f-1-1@2x.svg",
};

const twitterData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-157@2x.svg",
};

const group872Data = {
    overlapGroup: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-154@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-19@2x.svg",
    facebookAppSymbolProps: facebookAppSymbolData,
    twitterProps: twitterData,
};

// const footer5Data = {
//     group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/Webuildd-Logo-White.svg",
//     place: "Contact",
//     overlapGroup: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-20@2x.svg",
//     vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-21@2x.svg",
//     phone: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-14@2x.svg",
//     overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-15@2x.svg",
//     vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-16@2x.svg",
//     text15: "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.",
//     text14: "+91 8976535221, +91 8755645342",
//     contactWebuildCom: "contact@webuild.com",
//     quickLinks: "Quick Links",
//     aboutUs: "About Us",
//     projects: "Projects",
//     gallery: "Gallery",
//     knowledgeTransfer: "Knowledge Transfer",
//     blogs: "Blogs",
//     faqs: "FAQ’s",
//     group872Props: group872Data,
// };

const x06InsightsPageTabletData = {
    insights: "Insights",
    rectangle76: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-76-1@1x.png",
    text149: "WeBuildd has been delivering building solutions in Bengaluru and beyond for decades. But you are just getting started to turn your real estate dream into reality. So, let's go over some of the terminology and facts you'll encounter as you begin your journey.",
    text1492: "You are probably familiar with the authorities like the Bruhat Bengaluru Mahanagara Palike (BBMP), Bangalore Electricity Supply Company (BESCOM), Bangalore Water Supply and Sewerage Board (BWSSB), but are you aware of the bylaws and regulations that you have to keep in mind when planning your project ?",
    text1493: "Moreover, you must be aware of the actual costs of construction in Bengaluru to plan and fix a budget for your project. So, we have the information for you on that as well.",
    text1494: "Our steps of construction can be used as a map to start your project. We are sharing these insights to help you plan your journey more effectively.",
    text1495: "And don't forget to check out Vastu tips to design your home, as well as for house construction.",
    text1496: "So, let's get started...",
    frame144Props: frame144Data,
    insightsCardProps: insightsCardData,
    insightsCard2Props: insightsCard2Data,
    insightsCardProps2: insightsCard3Data,
    insightsCard2Props2: insightsCard4Data,
    insightsCardProps3: insightsCard5Data,
    insightsCard2Props3: insightsCard6Data,
    insightsCard7Props: insightsCard7Data,
    insightsCard8Props: insightsCard8Data,
    //footer5Props: footer5Data,
};

